import React from "react";

import { ProgressCircle, ProgressCircleProps } from "../ProgressRing";

export const ProgressPie = ({
  radius = 20,
  ...rest
}: Omit<
  ProgressCircleProps,
  "stroke" | "fontSize" | "showPercentage" | "roundStroke"
>) => {
  return <ProgressCircle {...rest} stroke={radius} radius={radius} />;
};

ProgressPie.displayName = "ProgressPie";
